import React from "react";
import useBlockedInsuranceHook from "./blockedInsuranceHook";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ReuseableButton from "../../../components/Buttons/button";
import { userColumns } from "./columns";
import { DataGrid } from "@mui/x-data-grid";

const BlockeInsurancetable = () => {
    const { blockedInsuranceState, handleGetRowId } = useBlockedInsuranceHook()
    const actionColumn = [
        {
          field: "action",
          headerName: "Action",
          width: 200,
          renderCell: (params) => {
            return (
              <div className="cellAction">
                  {/* <div className="viewButton" 
                //   onClick={()=>handleClick(params.row)}
                  >OPD</div> */}
                <div
                  className="deleteButton"
                //   onClick={() => handleDelete(params?.row?.uniqueID)}
                >
                  Release
                </div>
              </div>
            );
          },
        },
      ];

    return (
        <>
            <div className='d-flex justify-content-end'>
                <div className="mr-5">
                    <ReuseableButton
                        text={"Block Insurance"}
                        height={45}
                        colorVarient="success"
                        fullWidthFlag={true}
                        endIcon={<PersonAddAltIcon />}
                        // handleChange={handleIPDRoute}
                    />
                </div>
            </div>
            <div className="ipd-table p-2">
                <DataGrid
                    autoHeight
                    rows={blockedInsuranceState && blockedInsuranceState?.length > 0 ? blockedInsuranceState : []}
                    loading={blockedInsuranceState?.length > 0 || blockedInsuranceState === null ? false : true}
                    columns={userColumns.concat(actionColumn)}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={handleGetRowId}
                    checkboxSelection={false}
                />
            </div>
        </>
    )
};


export default BlockeInsurancetable